import _ from 'underscore'
import WMenu from '../components/WMenu'
import WEventsMixin from './w-events-mixin'

/**
 * @mixin
 */
export default {
    mixins: [WEventsMixin],
    props: {
        /**
         * Bulk array of actions to display on toolbar menu {title: '', event: '', color: '', icon: ''}
         */
        bulkMenuActions: {
            type: Array,
            default: () => []
        },
        /**
         * Bulk disable toolbar menu
         */
        bulkMenuDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Bulk toolbar menu icon
         */
        bulkMenuIcon: {
            type: String,
            default: 'fa-edit'
        },
        /**
         * Bulk toolbar menu icon color
         */
        bulkMenuIconColor: {
            type: String,
            default: ''
        },
        /**
         * Bulk show toolbar menu icon on hover
         */
        bulkMenuOnHover: {
            type: Boolean,
            default: false
        },
        /**
         * Bulk toolbar menu title
         */
        bulkMenuTitle: {
            type: String,
            default: 'With Selected...'
        },
        /**
         * Array of actions to display on toolbar menu {title: '', event: '', color: '', icon: ''}
         */
        menuActions: {
            type: Array,
            default: () => []
        },
        /**
         * Disable toolbar menu
         */
        menuDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Toolbar menu icon
         */
        menuIcon: {
            type: String,
            default: 'more_vert'
        },
        /**
         * Toolbar menu icon color
         */
        menuIconColor: {
            type: String,
            default: ''
        },
        /**
         * Show toolbar menu icon on hover
         */
        menuOnHover: {
            type: Boolean,
            default: false
        },
        /**
         * Toolbar menu title
         */
        menuTitle: {
            type: String,
            default: ''
        },
        /**
         * Tooltip for the menu
         */
        menuTooltip: {
            type: [String, Boolean],
            default: false
        },
    },
    components: {
        WMenu
    },
    computed: {
        hasMenuActions () {
            return !_.isEmpty(this.menuActions)
        },
        hasBulkMenuActions () {
            return !_.isEmpty(this.bulkMenuActions)
        }
    }
}
